import {
  Box,
  Button,
  OutlinedInput,
  Stack,
  Typography,
  FormHelperText,
} from '@mui/material';
import {Controller, useForm, useFormContext} from 'react-hook-form';
import React, {useEffect, useState} from 'react';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {usePoliceMode} from '../policeMode/hook/usePoliceMode';
import CheckIcon from '@mui/icons-material/Check';
import {useNavigation} from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const RegistrationStep1 = ({handleNextStep}) => {
  const {mode} = useDarkMode();
  const {police} = usePoliceMode();
  const [disabledEmailEdit, setDisabledEmailEdit] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword(show => !show);
  const [showPasswordConfirm, setShowPasswordConfirm] = React.useState(false);
  const [token, setToken] = useState();
  const handleClickShowPasswordConfirm = () =>
    setShowPasswordConfirm(show => !show);

  const {
    control,
    getValues,
    formState: {errors},
    handleSubmit,
  } = useFormContext();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const registerStrategyToken = params.get('token');
    setToken(registerStrategyToken);
    setDisabledEmailEdit(null !== registerStrategyToken);
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: mode.settings.card4BackgroundColor,
        padding: 5,
        width: {md: '75%', lg: '75%'},
      }}>
      <Stack alignItems={'center'} spacing={2}>
        <Typography
          variant={'subtitle7'}
          sx={{color: mode.settings.textColor3}}>
          Créez votre compte
        </Typography>
        <Box width={'100%'}>
          <Stack>
            <Typography
              variant={'subtitle1'}
              sx={{color: mode.settings.textColor3}}
              component={'label'}
              id={'label-email'}
              htmlFor={'email'}>
              Adresse email*
            </Typography>
            <Controller
              control={control}
              name="email"
              rules={{
                required: true,
                pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                validate: async value => {
                  const response = await fetch(
                    `${process.env.REACT_APP_API_BASE_URL}/check-email?email=${value}&token=${token}`,
                  );
                  const json = await response.json();
                  return json.exists ? 'Cet email est déjà utilisé' : true;
                },
              }}
              render={({field: {onChange, value}}) => (
                <div>
                  <OutlinedInput
                    disabled={disabledEmailEdit}
                    size="small"
                    id="email"
                    aria-describedby="label-email"
                    inputProps={{
                      'aria-label': 'weight',
                    }}
                    type={'text'}
                    value={value}
                    style={{maxWidth: 570, width: '100%', height: 52}}
                    sx={{
                      background: mode.settings.cardBackgroundColor,
                      color: mode.settings.textColor3,
                    }}
                    onChange={onChange}
                    error={!!errors.email}
                  />

                  {!!errors.email && (
                    <FormHelperText error>
                      {errors.email.message}
                    </FormHelperText>
                  )}
                </div>
              )}
            />
            <Typography
              variant={'subtitle1'}
              sx={{color: mode.settings.textColor3, marginTop: 2}}
              component={'label'}
              id={'label-password'}
              htmlFor={'password'}>
              Mot de passe*
            </Typography>
            <Controller
              control={control}
              name="password"
              rules={{
                  required: true,
                  pattern: {
                      value:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d@$!%*?&<>_#\.\-àáâäãåèéêëìíîïòóôöõùúûü]{8,}$/,
                      message:
                          'Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial',
                  },
                  minLength: {
                      value: 10,
                      message:
                          'Le mot de passe doit contenir au moins 10 caractères',
                  },
              }}
              render={({field: {onChange, value}}) => (
                <OutlinedInput
                  size="small"
                  id="password"
                  aria-describedby="label-password"
                  inputProps={{
                    'aria-label': 'weight',
                  }}
                  type={showPassword ? 'text' : 'password'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  value={value}
                  style={{maxWidth: 570, width: '100%', height: 52}}
                  sx={{
                    background: mode.settings.cardBackgroundColor,
                    color: mode.settings.textColor3,
                  }}
                  onChange={onChange}
                  error={!!errors.password}
                />
              )}
            />
            {!!errors.password && (
              <FormHelperText error>{errors.password.message}</FormHelperText>
            )}
            <Typography
              variant={'subtitle1'}
              sx={{color: mode.settings.textColor3, marginTop: 2}}
              component={'label'}
              id={'label-confirm-password'}
              htmlFor={'confirm-password'}>
              Confirmer le mot de passe*
            </Typography>
            <Controller
              control={control}
              name="confirmPassword"
              rules={{
                required: true,
                validate: value =>
                  value === getValues('password') || 'Non identiques',
              }}
              render={({field: {onChange, value}}) => (
                <div>
                  <OutlinedInput
                    size="small"
                    id="confirm-password"
                    aria-describedby="label-confirm-password"
                    inputProps={{
                      'aria-label': 'weight',
                    }}
                    type={showPasswordConfirm ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPasswordConfirm}
                          edge="end">
                          {showPasswordConfirm ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    value={value}
                    style={{maxWidth: 570, width: '100%', height: 52}}
                    sx={{
                      background: mode.settings.cardBackgroundColor,
                      color: mode.settings.textColor3,
                    }}
                    onChange={onChange}
                    error={!!errors.confirmPassword}
                  />
                  {!!errors.confirmPassword && (
                    <FormHelperText error>
                      {errors.confirmPassword.message}
                    </FormHelperText>
                  )}
                </div>
              )}
            />
          </Stack>
        </Box>

        <br />
        <Button
          className="btn-gradient"
          startIcon={<CheckIcon role="img" aria-label={'Valider'} />}
          style={{
            width: 200,
          }}
          onClick={() => handleNextStep && handleNextStep()}>
            <Typography variant={'subtitle3'}>
                Valider
            </Typography>

        </Button>
      </Stack>
    </Box>
  );
};

export default RegistrationStep1;
